<template>
  <div class="operationProcess">
    <div @click="see">
      <img
        style="width:100%;"
        :src="src"
      >
    </div>
    <div
      class="ps"
      @click="see"
    >点击可放大查看图片</div>
    <div
      class="btn"
      @click="goIndex"
    >进入</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      src: ""
    };
  },
  created() {
    let query = this.$route.query;
    if (query.type == 1) {
      this.src = "https://m.ibnsina360.com/护士扫码寄件流程.png";
    } else this.src = "https://m.ibnsina360.com/护士线下录入流程.png";
    if (!this.$store.state.wxConfigFlag) this.$wxConfig();
  },
  methods: {
    see() {
      this.wx.previewImage({
        current: this.src, // 当前显示图片的http链接
        urls: [this.src] // 需要预览的图片http链接列表
      });
    },
    goIndex() {
      let query = this.$route.query;
      if (query.type == 1) {
        this.$router.push({
          name: "nurseLogin"
        });
      } else
        this.$router.push({
          name: "sweepCodeBinding",
          query: {
            type: 2
          }
        });
    }
  }
};
</script>

<style lang='less' scoped>
.ps {
  text-align: center;
  font-size: 26px;
  color: #999;
  line-height: 50px;
}
.btn {
  width: 300px;
  height: 80px;
  line-height: 80px;
  border-radius: 80px;
  margin: 30px auto;
  text-align: center;
  background-color: #1968a8;
  color: #fff;
  font-size: 34px;
}
</style>
